import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { t } from "../../mode_constants-tb7TL85q.js";
import { BUTTON_ICON_SIZES as n, BUTTON_SIZE_MODIFIERS as r } from "../button/button-constants.js";
import { DialtoneLocalization as i } from "../../localization/index.js";
import a from "../button/button.js";
import o from "../checkbox/checkbox.js";
import s from "../checkbox-group/checkbox-group.js";
import c from "../list-item/list-item.js";
import l from "../stack/stack.js";
import { POPOVER_APPEND_TO_VALUES as u, POPOVER_PADDING_CLASSES as d } from "../popover/popover-constants.js";
import f from "../popover/popover.js";
import p from "../dropdown/dropdown.js";
import { Fragment as m, createBlock as h, createCommentVNode as g, createElementBlock as _, createElementVNode as v, createSlots as y, createTextVNode as b, createVNode as x, mergeProps as S, normalizeClass as C, openBlock as w, renderList as T, renderSlot as E, resolveComponent as D, resolveDirective as O, resolveDynamicComponent as k, toDisplayString as A, withCtx as j, withDirectives as M, withKeys as N, withModifiers as P } from "vue";
import { DtIconChevronDown as F, DtIconClose as I } from "@dialpad/dialtone-icons/vue";
//#region components/filter_pill/filter_pill.vue
var L = {
	name: "DtFilterPill",
	components: {
		DtCheckboxGroup: s,
		DtCheckbox: o,
		DtPopover: f,
		DtButton: a,
		DtIconClose: I,
		DtIconChevronDown: F,
		DtDropdown: p,
		DtListItem: c,
		DtStack: l
	},
	props: {
		useDropdown: {
			type: Boolean,
			default: !1
		},
		deferSelection: {
			type: Boolean,
			default: !1
		},
		modelValue: {
			type: Array,
			default: () => []
		},
		startTooltipText: {
			type: String,
			default: ""
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		readOnly: {
			type: Boolean,
			default: !1
		},
		showClear: {
			type: Boolean,
			default: !0
		},
		label: {
			type: String,
			default: void 0
		},
		endTooltipText: {
			type: String,
			default: ""
		},
		popoverAppendTo: {
			type: [HTMLElement, String],
			default: "body",
			validator: (e) => u.includes(e) || e instanceof HTMLElement
		},
		popoverFallbackPlacements: {
			type: Array,
			default: () => ["auto"]
		},
		popoverMaxHeight: {
			type: String,
			default: ""
		},
		popoverMaxWidth: {
			type: String,
			default: ""
		},
		popoverPadding: {
			type: String,
			default: "large",
			validator: (e) => Object.keys(d).some((t) => t === e)
		},
		popoverPlacement: {
			type: String,
			default: "bottom-start"
		},
		labelClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		popoverContentClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		popoverHeaderClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		popoverFooterClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		popoverDialogClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		dropdownListClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		contentMode: t,
		size: {
			type: [String, Number],
			default: 200,
			validator: (e) => Object.keys(r).includes(String(e))
		}
	},
	emits: [
		"clear",
		"open",
		"update:modelValue",
		"apply"
	],
	data() {
		return {
			isOpen: !1,
			i18n: new i(),
			filters: this.modelValue,
			pendingFilters: null
		};
	},
	computed: {
		overlayComponent() {
			return this.useDropdown ? "dt-dropdown" : "dt-popover";
		},
		overlayProps() {
			let e = {
				"append-to": this.popoverAppendTo,
				"fallback-placements": this.popoverFallbackPlacements,
				"max-height": this.popoverMaxHeight,
				"max-width": this.popoverMaxWidth,
				modal: !0,
				placement: this.popoverPlacement
			};
			return this.useDropdown ? e["list-class"] = this.dropdownListClass : (e.padding = this.popoverPadding, e["content-class"] = this.popoverContentClass, e["header-wrapper-class"] = this.popoverHeaderClass, e["footer-wrapper-class"] = this.popoverFooterClass, e["dialog-class"] = this.popoverDialogClass), e;
		},
		buttonKind() {
			return this.isActive && !this.disabled ? "default" : "muted";
		},
		resolvedStartTooltipText() {
			return this.readOnly ? this.startTooltipText || this.i18n.$t("DIALTONE_FILTER_PILL_READ_ONLY_TOOLTIP") : this.startTooltipText;
		},
		clearButtonAriaLabel() {
			return this.endTooltipText || this.i18n.$t("DIALTONE_FILTER_PILL_CLEAR_BUTTON_LABEL");
		},
		clearButtonTitle() {
			if (!this.endTooltipText) return this.clearButtonAriaLabel;
		},
		activeFilters() {
			return this.filters.filter((e) => e.active).map((e) => e.name);
		},
		activeFilterList() {
			return this.activeFilters.length === this.filters.length && this.filters.length > 1 ? "All" : this.activeFilters[0] ?? "";
		},
		activeFilterOverflow() {
			return this.activeFilters.length <= 1 || this.activeFilters.length === this.filters.length && this.filters.length > 1 ? "" : "+" + (this.activeFilters.length - 1);
		},
		isActive() {
			return this.activeFilterList.length > 0;
		},
		hasClear() {
			return !this.readOnly && this.showClear && this.activeFilterList.length > 0;
		},
		displayFilters() {
			return this.deferSelection && this.pendingFilters ? this.pendingFilters : this.filters;
		},
		pendingActiveFilters() {
			return this.pendingFilters ? this.pendingFilters.filter((e) => e.active).map((e) => e.name) : [];
		},
		cancelButtonLabel() {
			return this.i18n.$t("DIALTONE_FILTER_PILL_CANCEL_BUTTON_LABEL");
		},
		applyButtonLabel() {
			return this.i18n.$t("DIALTONE_FILTER_PILL_APPLY_BUTTON_LABEL");
		},
		clearIconSize() {
			return String(this.size) === "100" ? "100" : n[String(this.size)];
		}
	},
	watch: {
		isOpen(e) {
			this.$emit("open", e), this.deferSelection && (e ? this.pendingFilters = JSON.parse(JSON.stringify(this.filters)) : this.pendingFilters = null);
		},
		filters: {
			deep: !0,
			handler(e) {
				this.$emit("update:modelValue", e);
			}
		}
	},
	mounted() {
		this.modelValue?.length || this.$slots.content && this.$slots.content() || console.warn("Please provide content through the v-model or the \"content\" slot."), this.deferSelection && this.useDropdown && console.warn("deferSelection has no effect when useDropdown is true.");
	},
	methods: {
		clearFilter(e) {
			this.filters.forEach((e) => delete e.active), this.$emit("clear", e);
		},
		openPopover() {
			this.readOnly || (this.isOpen = !0);
		},
		selectFilter(e, t) {
			this.filters.forEach((t) => {
				t.active = t === e;
			}), t();
		},
		applySelection() {
			this.pendingFilters && (this.filters.forEach((e, t) => {
				this.pendingFilters[t] ? e.active = this.pendingFilters[t].active : delete e.active;
			}), this.$emit("apply"), this.isOpen = !1);
		},
		cancelSelection() {
			this.isOpen = !1;
		}
	}
}, R = ["title", "textContent"], z = ["title", "textContent"], B = ["title", "textContent"];
function V(e, t, n, r, i, a) {
	let o = D("dt-icon-chevron-down"), s = D("dt-button"), c = D("dt-checkbox"), l = D("dt-checkbox-group"), u = D("dt-stack"), d = D("dt-list-item"), f = D("dt-icon-close"), p = O("dt-tooltip");
	return w(), _("div", {
		class: C(["d-filter-pill", { "d-filter-pill--read-only": n.readOnly }]),
		"data-qa": "dt-filter-pill"
	}, [(w(), h(k(a.overlayComponent), S({
		open: i.isOpen,
		"onUpdate:open": t[0] || (t[0] = (e) => i.isOpen = e)
	}, a.overlayProps, { "content-mode": n.contentMode }), y({
		anchor: j((t) => [M((w(), h(s, S(n.useDropdown ? t : t.attrs, {
			active: a.isActive,
			"aria-disabled": n.readOnly || void 0,
			class: ["d-filter-pill__primary", { "d-filter-pill--selected": a.isActive }],
			disabled: n.disabled,
			kind: a.buttonKind,
			size: n.size,
			"data-qa": "dt-filter-pill__button",
			importance: "outlined",
			onClick: a.openPopover,
			onKeydown: N(P(a.openPopover, ["prevent"]), ["up", "down"])
		}), y({
			default: j(() => [v("span", { class: C(["d-filter-pill__label", n.labelClass]) }, [E(e.$slots, "default", {
				label: n.label,
				filters: i.filters,
				activeFilters: a.activeFilters,
				activeFilterList: a.activeFilterList,
				activeFilterOverflow: a.activeFilterOverflow
			}, () => [
				v("span", {
					class: "d-filter-pill__label-start",
					title: n.label,
					textContent: A(n.label)
				}, null, 8, R),
				a.activeFilterList ? (w(), _("span", {
					key: 0,
					class: "d-filter-pill__label-end",
					title: a.activeFilterList,
					textContent: A(a.activeFilterList)
				}, null, 8, z)) : g("", !0),
				a.activeFilterOverflow ? (w(), _("span", {
					key: 1,
					class: "d-filter-pill__label-end-overflow",
					title: `plus ${a.activeFilters.length - 1} others`,
					textContent: A(a.activeFilterOverflow)
				}, null, 8, B)) : g("", !0)
			])], 2)]),
			_: 2
		}, [e.$slots.startIcon ? {
			name: "startIcon",
			fn: j(({ iconSize: t }) => [E(e.$slots, "startIcon", { iconSize: t })]),
			key: "0"
		} : void 0, n.readOnly ? void 0 : {
			name: "endIcon",
			fn: j(({ iconSize: e }) => [x(o, {
				size: e,
				class: "d-filter-pill__icon",
				"data-qa": "dt-filter-pill__icon"
			}, null, 8, ["size"])]),
			key: "1"
		}]), 1040, [
			"active",
			"aria-disabled",
			"class",
			"disabled",
			"kind",
			"size",
			"onClick",
			"onKeydown"
		])), [[p, a.resolvedStartTooltipText]])]),
		_: 2
	}, [
		n.useDropdown ? void 0 : {
			name: "content",
			fn: j(({ close: t }) => [E(e.$slots, "content", {
				close: t,
				apply: a.applySelection,
				cancel: a.cancelSelection,
				pendingFilters: i.pendingFilters
			}, () => [n.modelValue?.length ? (w(), h(l, {
				key: 0,
				"model-value": n.deferSelection ? a.pendingActiveFilters : a.activeFilters,
				"aria-label": n.label,
				name: n.label || "filter-pill"
			}, {
				default: j(() => [(w(!0), _(m, null, T(a.displayFilters, (e) => (w(), h(c, {
					key: e.name,
					label: e.name,
					value: e.name,
					"onUpdate:modelValue": (t) => e.active = t
				}, null, 8, [
					"label",
					"value",
					"onUpdate:modelValue"
				]))), 128))]),
				_: 1
			}, 8, [
				"model-value",
				"aria-label",
				"name"
			])) : g("", !0)])]),
			key: "0"
		},
		!n.useDropdown && e.$slots.headerContent ? {
			name: "headerContent",
			fn: j(({ close: t }) => [E(e.$slots, "headerContent", { close: t })]),
			key: "1"
		} : void 0,
		!n.useDropdown && (n.deferSelection || e.$slots.footerContent) ? {
			name: "footerContent",
			fn: j(({ close: t }) => [E(e.$slots, "footerContent", {
				close: t,
				apply: a.applySelection,
				cancel: a.cancelSelection
			}, () => [n.deferSelection ? (w(), h(u, {
				key: 0,
				direction: "row",
				gap: "400",
				justify: "end",
				"data-qa": "dt-filter-pill__deferred-footer"
			}, {
				default: j(() => [x(s, {
					importance: "clear",
					kind: "muted",
					size: 200,
					"data-qa": "dt-filter-pill__cancel-button",
					onClick: a.cancelSelection
				}, {
					default: j(() => [b(A(a.cancelButtonLabel), 1)]),
					_: 1
				}, 8, ["onClick"]), x(s, {
					importance: "primary",
					size: 200,
					"data-qa": "dt-filter-pill__apply-button",
					onClick: a.applySelection
				}, {
					default: j(() => [b(A(a.applyButtonLabel), 1)]),
					_: 1
				}, 8, ["onClick"])]),
				_: 1
			})) : g("", !0)])]),
			key: "2"
		} : void 0,
		n.useDropdown ? {
			name: "list",
			fn: j(({ close: t }) => [E(e.$slots, "content", { close: t }, () => [(w(!0), _(m, null, T(i.filters, (e) => (w(), h(d, {
				key: e.name,
				role: "menuitem",
				"navigation-type": "arrow-keys",
				selected: e.active,
				onClick: (n) => a.selectFilter(e, t)
			}, {
				default: j(() => [b(A(e.name), 1)]),
				_: 2
			}, 1032, ["selected", "onClick"]))), 128))])]),
			key: "3"
		} : void 0
	]), 1040, ["open", "content-mode"])), a.hasClear ? M((w(), h(s, {
		key: 0,
		active: a.isActive,
		"aria-label": a.clearButtonAriaLabel,
		class: C(["d-filter-pill__clear", { "d-filter-pill__clear--selected": a.isActive }]),
		disabled: n.disabled,
		kind: a.buttonKind,
		size: n.size,
		title: a.clearButtonTitle,
		"data-qa": "dt-filter-pill__clear-button",
		importance: "outlined",
		onClick: a.clearFilter
	}, {
		icon: j(() => [x(f, { size: a.clearIconSize }, null, 8, ["size"])]),
		_: 1
	}, 8, [
		"active",
		"aria-label",
		"class",
		"disabled",
		"kind",
		"size",
		"title",
		"onClick"
	])), [[p, n.endTooltipText]]) : g("", !0)], 2);
}
var H = /* @__PURE__ */ e(L, [["render", V]]);
//#endregion
export { H as default };

//# sourceMappingURL=filter-pill.js.map